import { ref } from 'vue';

import { usePollenStore } from '@/stores/pollen_store';

export function useRecoveryKit() {
  const pollenStore = usePollenStore();
  const downloading = ref(false);
  const error = ref('');

  async function downloadRecoveryKit() {
    if (downloading.value) return;
    downloading.value = true;
    error.value = '';
    try {
      const { email, secretKey, authType } = pollenStore;
      if (!email || !secretKey) {
        error.value = 'Unlock your account and app library before downloading your Recovery Kit.';
        return;
      }
      // Account authType does not change when a password user enrolls a passkey.
      // Refresh enrollment rather than relying on the sign-in method or cached UI state.
      const passkeys = await pollenStore.refreshPasskeys();
      // Keep the renderer and PDF dependencies out of the initial application bundle.
      const { downloadRecoveryKitPDF } = await import('@/util/recovery_kit_pdf');
      await downloadRecoveryKitPDF({
        email,
        secretKey,
        authType,
        hasPasskey: passkeys.length > 0,
        origin: window.location.origin,
      });
    } catch {
      // Never log errors containing account data or the recovery URL.
      error.value = 'Unable to download your Recovery Kit. Please try again.';
    } finally {
      downloading.value = false;
    }
  }

  return { downloadRecoveryKit, downloading, error };
}
